import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

export function useTagTeamRequestsCount(user: User | null | undefined) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) {
      setCount(0);
      return;
    }

    const fetchCount = async () => {
      const { count: requestCount, error } = await supabase
        .from("team_invitations")
        .select("*", { count: "exact", head: true })
        .eq("invitee_id", user.id)
        .eq("status", "pending");

      if (!error && requestCount !== null) {
        setCount(requestCount);
      }
    };

    fetchCount();

    // Subscribe to real-time changes
    const channel = supabase
      .channel("team_invitations_count")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "team_invitations",
          filter: `invitee_id=eq.${user.id}`,
        },
        () => {
          fetchCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

  return count;
}
